module.exports = __webpack_public_path__ + "img/hlhkzxt3.82168788.jpg";